import React from 'react';
import { motion } from 'motion/react';
import { useAuth } from '@/src/contexts/AuthContext';

interface Props {
  onConnect: () => void;
}

const OptimizeHub: React.FC<Props> = ({ onConnect }) => {
  const { user, userProfile } = useAuth();

  return (
    <div className="relative bg-[#3a3430] border border-white/[0.06] rounded-xl p-6 sm:p-10 transition-all overflow-hidden h-full min-h-[580px] flex flex-col text-left">
      <div className="relative z-10 space-y-6 md:space-y-8 flex-1 flex flex-col">
        <div className="flex items-center justify-between">
          <div className="w-8 h-8 rounded bg-[#F26522] text-white flex items-center justify-center font-bold text-sm">
            O
          </div>
          <div className="text-right">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#F26522]">Scale What Works</span>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-xl font-medium tracking-tight text-white">eNvesta AI Optimize</h2>
          <p className="text-xs text-white/60 leading-relaxed font-normal">
            Scale what works. Connect your active business. Track actuals against original projections. Model expansions, pricing changes, and new locations. Get automated market alerts and living SWOT updates.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 bg-[#322D29] border border-white/[0.08] rounded-lg space-y-1.5">
            <p className="text-[10px] font-medium uppercase tracking-wider text-[#F26522]">Growth Math</p>
            <p className="text-xs text-white/70 leading-normal">Model expansion capex & franchise scenarios.</p>
          </div>
          <div className="p-4 bg-[#322D29] border border-white/[0.08] rounded-lg space-y-1.5">
            <p className="text-[10px] font-medium uppercase tracking-wider text-[#F26522]">Live Ops</p>
            <p className="text-xs text-white/70 leading-normal">Track prediction accuracy & cash runway.</p>
          </div>
        </div>
      </div>

      <div className="mt-auto pt-6">
        <button 
          onClick={onConnect}
          className="w-full py-3 bg-[#F26522] hover:bg-[#F26522]/90 text-white font-medium uppercase text-xs tracking-wider rounded-lg transition-all flex items-center justify-center gap-2 cursor-pointer"
        >
          <span>Connect Business</span>
          <i className="fas fa-arrow-right text-xs"></i>
        </button>
      </div>
    </div>
  );
};

export default OptimizeHub;
